import UrlOpenQuestion from 'models/common/form/question/open/UrlOpenQuestion';

export default class UrlOpenQuestionService {
	toModel(question) {
		return new UrlOpenQuestion(question);
	}
}
